module.exports = __webpack_public_path__ + "media/images/lp_v6_img10_sp-185fae86ca08dfb544ce5a9bb2f61e01.webp";